var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RankingHeader = require("./RankingHeader");

var _Basic = require("../../../elements/Basic");

var _Table = _interopRequireDefault(require("../Table"));

var _RankingRow = require("./RankingRow");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _Button = _interopRequireDefault(require("../Basic/Button"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Ranking/index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Ranking = function (_React$Component) {
  (0, _inherits2.default)(Ranking, _React$Component);

  var _super = _createSuper(Ranking);

  function Ranking() {
    var _this;

    (0, _classCallCheck2.default)(this, Ranking);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderButton = function (showMore, showMoreHref) {
      return _react.default.createElement(_Button.default, {
        title: (0, _i18n.default)('basic_more'),
        width: 96,
        onPress: showMore,
        href: showMoreHref,
        regular: _this.props.regular,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 9
        }
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Ranking, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ranking = _this$props.ranking,
          isPreview = _this$props.isPreview,
          onRowPress = _this$props.onRowPress,
          showMore = _this$props.showMore,
          showMoreHref = _this$props.showMoreHref,
          createHref = _this$props.createHref,
          renderButton = _this$props.renderButton,
          rowStyles = _this$props.rowStyles,
          titleStyles = _this$props.titleStyles,
          titlePrefix = _this$props.titlePrefix,
          headerRowStyles = _this$props.headerRowStyles,
          buttonRowStyles = _this$props.buttonRowStyles,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["ranking", "isPreview", "onRowPress", "showMore", "showMoreHref", "createHref", "renderButton", "rowStyles", "titleStyles", "titlePrefix", "headerRowStyles", "buttonRowStyles", "NavWrapper"]);
      if (!ranking || !ranking.entries.length) return null;
      var rankingType = ranking.type;
      var header = (0, _RankingHeader.RankingHeader)(_objectSpread({}, {
        rankingType: rankingType,
        headerRowStyles: headerRowStyles
      }));
      return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
        p: 2,
        isFlex: true
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74,
          columnNumber: 13
        }
      }), (isPreview || titleStyles.forceTitle) && _react.default.createElement(_Basic.Heading, (0, _extends2.default)({}, titleStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76,
          columnNumber: 21
        }
      }), titlePrefix, titleStyles.upperCase ? (0, _i18n.default)("ranking_title_" + ranking.type).toUpperCase() : (0, _i18n.default)("ranking_title_" + ranking.type)), _react.default.createElement(_Table.default, (0, _extends2.default)({
        onPress: onRowPress,
        mb: 1,
        items: ranking.entries,
        content: ranking.entries.map(function (item) {
          return (0, _RankingRow.RankingRow)(_objectSpread({}, {
            rankingType: rankingType,
            item: item
          }));
        }),
        rowStyles: rowStyles
      }, {
        header: header,
        createHref: createHref,
        NavWrapper: NavWrapper
      }, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 17
        }
      })), isPreview && ranking.entries.length >= 3 && _react.default.createElement(_Basic.Row, (0, _extends2.default)({}, buttonRowStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 21
        }
      }), typeof renderButton === 'function' ? renderButton(showMore, showMoreHref) : this.renderButton(showMore, showMoreHref)));
    }
  }]);
  return Ranking;
}(_react.default.Component);

Ranking.propTypes = {
  ranking: _propTypes.default.object.isRequired,
  button: _propTypes.default.object,
  isPreview: _propTypes.default.bool,
  showMore: _propTypes.default.func,
  showMoreHref: _propTypes.default.string,
  onRowPress: _propTypes.default.func,
  createHref: _propTypes.default.func,
  renderButton: _propTypes.default.func,
  rowStyles: _propTypes.default.object,
  titleStyles: _propTypes.default.object,
  titlePrefix: _propTypes.default.string,
  headerRowStyles: _propTypes.default.object,
  buttonRowStyles: _propTypes.default.object,
  NavWrapper: _propTypes.default.func
};
Ranking.defaultProps = {
  titleStyles: {
    center: true,
    bold: true,
    size: 'large',
    my: 1
  },
  buttonRowStyles: {
    center: true
  }
};
var _default = Ranking;
exports.default = _default;